module.exports = __webpack_public_path__ + "static/media/incorrect-icon.6636d848.svg";